export interface UserContextRoleScopeHeadersDTO {
    scopeField1Name?: string;
    scopeField2Name?: string;
    scopeField3Name?: string;
    scopeField4Name?: string;
}
